module.exports = __webpack_public_path__ + "img/footer-bg_mob.9f266ec.webp";